'use strict';

angular.module('contentful').directive('cfPlatformUsage', [
  'require',
  require => {
    const React = require('react');
    const ReactDOM = require('react-dom');
    const OrganizationUsage = require('account/usage/OrganizationUsage.es6').default;

    return {
      link: function($scope, el) {
        const host = el[0];
        const context = $scope.properties.context;

        ReactDOM.render(
          <OrganizationUsage
            orgId={$scope.properties.orgId}
            onReady={function() {
              context.ready = true;
              $scope.$applyAsync();
            }}
            onForbidden={function() {
              context.forbidden = true;
            }}
          />,
          host
        );

        $scope.$on('$destroy', () => {
          ReactDOM.unmountComponentAtNode(host);
        });
      }
    };
  }
]);



// WEBPACK FOOTER //
// ./src/javascripts/account/usage/cf_platform_usage_directive.js